import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InfoBox } from './InfoBox';

interface RowDirectionControlProps {
  selectedRowIndex: number | null;
  selectedRowName: string | null;
  onReverseDirection: () => void;
}

export const RowDirectionControl: React.FC<RowDirectionControlProps> = ({
  selectedRowIndex,
  selectedRowName,
  onReverseDirection,
}) => {
  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.row_direction.title')} style={{ marginBottom: "15px" }}>
      {selectedRowIndex !== null ? (
        <>
          <Typography variant="body2" style={{ marginBottom: "10px" }}>
            {translate('osfc.storage_ui.row_direction.selected')} <strong>{selectedRowName}</strong>
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                onClick={onReverseDirection}
                variant="contained"
                color="primary"
                fullWidth
              >
                {translate('osfc.storage_ui.row_direction.reverse')}
              </Button>
            </Grid>
          </Grid>
          <Typography variant="caption" style={{ marginTop: "10px", display: "block", color: "#888" }}>
            {translate('osfc.storage_ui.row_direction.caption')}
          </Typography>
        </>
      ) : (
        <Typography variant="body2" style={{ color: "#888" }}>
          {translate('osfc.storage_ui.row_direction.hint')}
        </Typography>
      )}
    </InfoBox>
  );
};
